import { render, staticRenderFns } from "./NovoFuncionario.vue?vue&type=template&id=4c3b0254&"
import script from "./NovoFuncionario.vue?vue&type=script&lang=js&"
export * from "./NovoFuncionario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports